import React from "react";
import { useTheme } from "styled-components";
import authSvgPaths from "_assets/auth-svg-paths";

const DecorativeBlobsBg = () => {
  const theme = useTheme();
  const isDark = theme.palette.background.auth === "#16283A";

  return (
    <div
      style={{
        position: "absolute",
        left: "-8px",
        top: "0",
        width: "662px",
        height: "857px",
        pointerEvents: "none",
        zIndex: -1,
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: "-19.15% -7.05% 0 -24.8%",
        }}
      >
        <svg
          style={{ display: "block", width: "100%", height: "100%" }}
          fill="none"
          preserveAspectRatio="none"
          viewBox="0 0 872.798 1021.19"
        >
          <g>
            {!isDark && (
              <g filter="url(#auth_blob_f0)">
                <ellipse
                  cx="501.701"
                  cy="585.574"
                  fill="white"
                  rx="140.206"
                  ry="110.936"
                />
              </g>
            )}
            {!isDark && (
              <path
                d={authSvgPaths.pd987f80}
                opacity="0.2"
                stroke="#F5F5F5"
                strokeWidth="0.676042"
              />
            )}
            <g filter="url(#auth_blob_f1)">
              <ellipse
                cx="301.66"
                cy="284.359"
                fill="#3636F2"
                fillOpacity="0.4"
                rx="137.5"
                ry="120.199"
              />
            </g>
            {!isDark && (
              <path
                d={authSvgPaths.p19d2d940}
                opacity="0.2"
                stroke="#F5F5F5"
                strokeWidth="0.676042"
              />
            )}
            <path
              d={authSvgPaths.p3de20700}
              opacity="0.2"
              stroke="#F5F5F5"
              strokeWidth={isDark ? "0.15" : "0.676042"}
            />
            <path
              d={authSvgPaths.p163e4b30}
              opacity="0.2"
              stroke="#F5F5F5"
              strokeWidth={isDark ? "0.15" : "0.676042"}
            />
            {!isDark && (
              <g filter="url(#auth_blob_f2)">
                <ellipse
                  cx="291.92"
                  cy="101.164"
                  fill="#DDE2E7"
                  rx="291.92"
                  ry="101.164"
                  transform="matrix(0.948515 -0.316731 0.470621 0.882336 177.16 449.957)"
                />
              </g>
            )}
            {!isDark && (
              <g filter="url(#auth_blob_f3)">
                <ellipse
                  cx="127.811"
                  cy="32.2393"
                  fill="white"
                  fillOpacity="0.7"
                  rx="127.811"
                  ry="32.2393"
                  transform="matrix(0.948515 -0.316731 0.470621 0.882336 376.663 399.497)"
                />
              </g>
            )}
            <path
              d={authSvgPaths.p332f1300}
              opacity="0.2"
              stroke="#F5F5F5"
              strokeWidth={isDark ? "0.15" : "0.676042"}
            />
            <path
              d={authSvgPaths.pa64a400}
              opacity="0.2"
              stroke="#F5F5F5"
              strokeWidth={isDark ? "0.15" : "0.676042"}
            />
          </g>
          <defs>
            <filter
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
              height="402.15"
              id="auth_blob_f0"
              width="460.691"
              x="271.355"
              y="384.499"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                mode="normal"
                result="shape"
              />
              <feGaussianBlur stdDeviation="45.0695" />
            </filter>
            <filter
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
              height="568.718"
              id="auth_blob_f1"
              width="603.321"
              x="0"
              y="0"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                mode="normal"
                result="shape"
              />
              <feGaussianBlur stdDeviation="82.0801" />
            </filter>
            <filter
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
              height="437.309"
              id="auth_blob_f2"
              width="742.276"
              x="130.522"
              y="228.103"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                mode="normal"
                result="shape"
              />
              <feGaussianBlur stdDeviation="45.0695" />
            </filter>
            <filter
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
              height="189.101"
              id="auth_blob_f3"
              width="334.518"
              x="345.808"
              y="292.911"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                mode="normal"
                result="shape"
              />
              <feGaussianBlur stdDeviation="22.5347" />
            </filter>
          </defs>
        </svg>
      </div>
    </div>
  );
};

export default DecorativeBlobsBg;
